import { useEffect, useState, useRef } from "react";
import useAPI from "../../../services/hooks/useAPI";
import searchAPI from "../../API/searchAPI";
import { useLocation, useNavigate } from "react-router-dom";
import { DataGrid, getGridStringOperators, GridColDef, GridFilterModel, GridPaginationModel, GridSortModel } from '@mui/x-data-grid';
import SearchBar from "../../app/SearchBar/SearchBar";
import { Button, Skeleton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ViewDownloadsDialog } from "../../dialogs/View-Downloads-Dialog";
import { useAuth } from "../../../hooks/useAuth";
import './style.scss';
import instance from "../../../services/axiosInstance";
import { CacheService } from "../../../common/services/cache.service";
import environment from "../../../environment/environment";
import APIService from "../../../services/api.service";
import { UserUploadDialog } from "../../dialogs/User-Upload-Dialog";

import { useRecoilState } from "recoil";
import { tokenState } from "../../../atoms/token";
import { RejectDialog } from "../../dialogs/Reject-Dialog";
import axios from "axios";
import { filter } from "lodash";


const UserUploads = () => {
  const { user } = useAuth();

  const [loading, setLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const [showRejectDialog, setShowRejectDialog] = useState(false);

  //const [row, setRow] = useState(null);
  const [uploads, setUploads] = useState([]);
  const [resultCount, setResultCount] = useState(0);
  const [token, setToken] = useRecoilState(tokenState);

  const [filterModel, setFilterModel] = useState<GridFilterModel>({ items: [] });
  const [paginationModel, setPaginationModel] = useState<GridPaginationModel>({
    pageSize: 25,
    page: 0,
  });
  const [sortModel, setSortModel] = useState<GridSortModel>([]);

  const navigate = useNavigate();
  const myrow = useRef(null);

  useEffect(() => {
    getUploads();
  }, [paginationModel, filterModel, sortModel]);

  const getUploads = async () => {
    setLoading(true);

    let queryParts = [];

    if (sortModel.length && Object.keys(sortModel[0]).length > 0 && sortModel[0]?.field && sortModel[0].field !== 'action') {
      queryParts.push(`sortField=${sortModel[0].field}`);
      queryParts.push(`sortDirection=${sortModel[0].sort === 'desc' ? 'desc' : 'asc'}`);
    }

    queryParts.push(`page=${paginationModel.page + 1}&pageSize=${paginationModel.pageSize}`);

    if (filterModel.items?.length > 0) {
      queryParts.push(`filterField=${filterModel.items[0].field}`);
      queryParts.push(`filterOperator=${filterModel.items[0].operator}`);
      queryParts.push(`filterValue=${filterModel.items[0].value}`);
    }

    const url = `${environment.npgApiUrl}etic/GetUserUploads?${queryParts.join('&')}`;

    try 
    {
      await new APIService<any>(axios, new CacheService, url, token)
              .getAnyAsync<any>()
              .then((res:any) => {
          setResultCount(res.totalCount)
          console.log('uploads', res);
          setUploads(res.data);
      });
    } 
    catch (err) 
    {
      console.error('Failed to load users', err);
      setUploads([]);
    } finally {
      setLoading(false);
    }


  }

  const handleRowBtnClick = (event, rowParams) => {
    //setRow(rowParams.row);
    myrow.current = rowParams.row;
    console.log('myrow', myrow.current);

    if(myrow.current.status === 'Rejected') {
      handleUnRejectClick();
    } else {
      setShowRejectDialog(true);
    }
  }

  const handleRejectClick = (reason: string) => {
    let url = `${environment.eticApiUrl}RejectUserUpload?id=${myrow.current?.id}&reason=${reason}`;
    
    const apiService = new APIService<any>(instance, new CacheService, url, token);
    apiService.getAnyAsync().then((res:any) => {
      getUploads();
    });

    setShowDialog(false);
    setShowRejectDialog(false);
    //setRow(null);
  }

  const handleCloseClick = () => {
    setShowRejectDialog(false);
    setShowDialog(false);
    //setRow(null);
  }

  const handleSaveClick = (form: any) => {
    setShowDialog(false);
    //setRow(null);
    try{
      // 1. Get Current User Upload
      const url = `${environment.eticApiUrl}GetUserUpload/${myrow.current?.id}`;
      const apiService = new APIService<any>(instance, new CacheService, url, token);

      apiService.getAnyAsync().then((res:any) => {
        console.log('get', res);

        // 2. merge in only the fields the user edited
        const payload = { ...res, ...form };    

        // 3. post the updated object back
        const updateUrl = `${environment.eticApiUrl}UpdateUserUpload`;
        const updateApiService = new APIService<any>(instance, new CacheService, updateUrl, token);
        updateApiService.add(payload).then((res:any) => {

          console.log("Updated upload:", res);

          // 4. navigate to the record page, passing along the updated form
          navigate("/record", { state: { form: res } });
        });
        
    });
  }
  catch (err) {
    console.error("Failed to save updated upload:", err);
    // you might want to show a Snackbar or Alert here
  }
  console.log('save', form);
}

  const handleRejectUploadDialogClick = () => { 
    setShowDialog(false);
    setShowRejectDialog(true);
  }

  const handleUnRejectClick = () => {
    let url = `${environment.eticApiUrl}RejectUserUpload?id=${myrow.current?.id}`;
    if(myrow.current?.status === 'Rejected') { url += '&reject=false';}

    const apiService = new APIService<any>(instance, new CacheService, url, token);
    apiService.getAnyAsync().then((res:any) => {
      getUploads();
    });

    setShowDialog(false);
    //setRow(null);
  }

  const handleRowClick = (rowArgs, event) => {
    myrow.current = rowArgs.row;
    console.log('row', rowArgs);
    if(rowArgs.row.status === 'Complete') { 
      navigate('/record/' + rowArgs.row.ticParentDocId);
    } else {
      //setRow(rowArgs.row);
      setShowDialog(true);
    }
  }

  const formatDate = (date) => { 
    let d = new Date(date);
    return d.toLocaleDateString();
  }

  const columns: GridColDef[] = [
    { field: 'userId', 
      headerName: 'Uploaded By', 
      width: 150,
      type : 'string',
      filterOperators : getGridStringOperators().filter(
        (operator) => operator.value === 'contains' || operator.value === 'equals' || operator.value === 'startsWith' || operator.value === 'endsWith'
      )
    },
    { field: 'ticStaff', 
      headerName: 'TIC Staff', 
      width: 150,
      type : 'string',
      filterOperators : getGridStringOperators().filter(
        (operator) => operator.value === 'contains' || operator.value === 'equals' || operator.value === 'startsWith' || operator.value === 'endsWith'
      )
    },
    { field: 'dateUploaded', headerName: 'Date Submitted', width: 150, filterable : false},
    { field: 'parkName', 
      headerName: 'Park Name', 
      width: 150,
      type : 'string',
      filterOperators : getGridStringOperators().filter(
        (operator) => operator.value === 'contains' || operator.value === 'equals' || operator.value === 'startsWith' || operator.value === 'endsWith'
      )
    },
    { field: 'title', 
      headerName: 'Doc Title', 
      width: 150,
      type : 'string',
      filterOperators : getGridStringOperators().filter(
        (operator) => operator.value === 'contains' || operator.value === 'equals' || operator.value === 'startsWith' || operator.value === 'endsWith'
      )

    },
    //{ field: 'attachment', headerName: 'Attachment', width: 150},
    { field: 'file', headerName: 'File', width: 150, headerClassName: 'bold', filterable : false, sortable : false, renderCell: (cellValues) => {
      return (
        <>
          {cellValues.row.ticParentDocId ?
            <img 
              style={{'backgroundSize': 'contain', 'width':  '100px', 'height': '100px','objectFit': 'contain' }} 
              src={`https://npgallery.nps.gov/api/ETIC/getparentthumbnail/${cellValues.row.ticParentDocId}`} 
            />
            :
            // <span>{cellValues.row}</span>
            <span>{cellValues.row.fileName}</span>
          }
        </>    
      );
    } },
    { field: 'status', 
      headerName: 'Status', 
      width: 150, 
      type : 'string',
      filterOperators : getGridStringOperators().filter(
        (operator) => operator.value === 'contains' || operator.value === 'equals' || operator.value === 'startsWith' || operator.value === 'endsWith'
      )
    },
    //{ field: 'eticUrl', headerName: 'eTIC Url', width: 150},
    { field: 'action', headerName: 'Action',
      hideSortIcons: true,
      sortable : false,
      filterable : false,
      width: 200,
      renderCell: (cellValues) => {
        return (
          <>
            { cellValues.row.status !== 'Complete' &&
              <Button
              variant={"contained"} 
              color={"primary"}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                handleRowBtnClick(event, cellValues);
              }}
              // fontawesome icon for edit
              
              startIcon={cellValues?.row?.status === 'Rejected' ? <FontAwesomeIcon icon={["fas", "file-check"]}/> : <FontAwesomeIcon icon={["fas", "file-xmark"]}/>}
              >
                {cellValues?.row?.status === 'Rejected' ? 'UnReject' : 'Reject'}
              </Button>
            }
          </> 
        );
      }
    },
    { field: 'view', headerName: 'View',
      hideSortIcons: true,
      sortable : false,
      filterable : false,
      width: 200,
      renderCell: (cellValues) => {
        return (
          <Button
            variant={"contained"} 
            color={"primary"}
            onClick={(event) => {
              event.preventDefault();
              event.stopPropagation();
              handleRowClick(cellValues, event);
            }}
            // fontawesome icon for edit
            
            startIcon={<FontAwesomeIcon icon={["fas", "eye"]}/>}
          >
            {'View'}
          </Button>
        );
      }
    },
  ];
  
  return (
    <>
      {showDialog &&
            <UserUploadDialog
              row={myrow.current}
              handleRejectUploadDialogClick={handleRejectUploadDialogClick}
              handleUnRejectClick={handleUnRejectClick}
              handleSaveClick={handleSaveClick}
              handleCloseClick={handleCloseClick}
            />
      }

      {showRejectDialog &&
            <RejectDialog
              handleRejectClick={handleRejectClick}
              handleCloseClick={handleCloseClick}
            />
      }

      <h1 className="center">User Uploads</h1>
    
      <div className="search-results">
        <div className="center" style={{ height: 400, width: '100%' }}>
          <DataGrid
            sx={{ '.MuiDataGrid-columnHeaderTitle': {fontWeight: 'bolder'},
            '.MuiDataGrid-columnHeaderTitleContainer': {borderBottom: 1 },
            '.MuiDataGrid-row': {cursor: 'pointer', borderBottom: 1},
            '.MuiDataGrid-iconButtonContainer': {visibility: 'visible' },
            '.MuiDataGrid-sortIcon': {opacity: 'inherit !important' }
           }}
            rows={uploads.map((row, index) => (
              {
                id: row?.id,
                userId: row?.userId,
                ticStaff: row?.lastModifiedByName,
                title: row?.title,
                file: '',
                ticParentDocId: row?.ticParentDocId,
                dateUploaded: formatDate(row?.dateUploaded),
                status: row?.status,
                parkName: row?.parkName,
                docTypeId: row?.docTypeId,
                docType: row?.docType,
                pmisNumber: row?.pmisNumber,
                parkId: row?.parkId,
                comments: row?.comments,
                ticNumber: row?.ticNumber,
                fileName: row?.fileName.length ? row?.fileName[0] : '',

              }
            )) || []}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 5 },
              },
            }}
            onRowClick={handleRowClick}
            disableRowSelectionOnClick
            loading={loading}
            rowCount={resultCount}
            paginationModel={paginationModel}
            pageSizeOptions={[5, 10, 25, 50]}
            sortingMode="server"
            filterMode="server"
            paginationMode="server"
            onPaginationModelChange={setPaginationModel}
            onFilterModelChange={setFilterModel}
            onSortModelChange={setSortModel}
          />
        </div>
      </div>
    </>
  );
}

export default UserUploads;